import { ActionCreatorBase } from 'Widgets/Scripts/ModernWidgetTypes/ActionCreatorBase';

export class VelocityActionCreator extends ActionCreatorBase {}